import { makeStyles } from 'tss-react/mui';

export const useReducedProductPricesV2Styles = makeStyles()(() => ({
  root: {
    border: 'none',
    maxHeight: '100%',
    overflowY: 'hidden',
    '& .MuiTableCell-head': {
      color: 'inherit',
      border: 'none',
      '& .MuiTypography-root': { maxWidth: '125px' },
    },
    '& .MuiTableCell-root': {
      color: 'inherit',
      border: 'none',
      textAlign: 'right',
      verticalAlign: 'bottom',
      whiteSpace: 'nowrap',
    },
    '& .MuiTableCell-sizeSmall': {
      padding: '0px 0px 4px 0px',
    },
  },
  lastRow: {
    '& .MuiTableCell-sizeSmall': {
      padding: '0px',
    },
  },
}));
